<template>
  <div class="dailydetail w98">
    <div class="crumbs">
      <!-- <span><router-link to="/HospitalImage">首页</router-link>  > </span> -->
      <span>首页</span>>
      <span><router-link to="/DailyMeeting">每日读片</router-link> ></span>
      <span>读片详情</span>
    </div>
  <!--title-->
      <div class="daily-title">
        <div class="bigtit">{{events.title }} </div>
        <el-tag>{{ events.confType }}</el-tag>
        <span class="meet-times" >{{events.startTime + ' ~ ' + events.endTime}}</span>

        <el-button class="open-vedio" size="small" @click="startConfView" >{{btnText}}</el-button>
        <el-dropdown class="members fr">
          <span class="el-dropdown-link">
           <el-badge :value="memberCount" class="item" :max="99">
            参会人员
            </el-badge>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item,index) in attendList" disabled :key="index">{{ item.docName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

  <!-- content -->
    <div class="clearfix" style="width: 100%;">
         <div class="layout-left">
              <tabs class="mytab" @tabChange="tabChange" :activeName="'0'">
                  <!--附件-->
                <el-tab-pane name="0">
                   <span slot="label">附件({{attachList.length}})</span>
                    <el-collapse class="files" v-model="collapseActive">
                      <el-collapse-item name="0">
                        <template slot="title">
                          <label>文档类型</label>
                          <a href="javascript:;" class="add-btn">从我的电脑选择
                            <input type="file"
                             picType="ppt/*,pptx/*,pdf/*,doc/*,docx/*,rtf/*,xls/*"
                            @change="changeFn($event,1)" @click="addFile('1')"  multiple="multiple" :accept="fileType"></a>
                        </template>
                        <div class="file-list query_medicalRecord_left_file_content">
                          <p v-for="(fj,index) in fileannex" :key="index" :class="{check: index == fileI}" :title="fj.label" @click="fileCLick('file', fj, index)">{{fj.label}}</p>
                        </div>
                      </el-collapse-item >
                      <el-collapse-item name="1">
                        <template slot="title">
                          <label>图片类型</label>
                          <a href="javascript:;" class="add-btn">从我的电脑选择 <input type="file"    fileType="image/*"
                           @change="changeFn($event,2)" @click="addFile('2')"  multiple="multiple" :accept="picType"></a>
                        </template>
                        <div class="file-list query_medicalRecord_left_file_content">
                          <p v-for="(fj,index) in picannex" :key="index" :class="{check: index == picI}" :title="fj.label" @click="fileCLick('img', fj, index)">{{fj.label}}</p>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                </el-tab-pane>
                 <el-tab-pane name="1">
                    <span slot="label">影像({{studyList.length}})</span>
                <!--影像-->
                  <!-- <div v-show="activeName === '1'"> -->
                    <div style="height:40px; padding-top: 10px;">
                      <radius-input @searchClick="videosearchClick" :markedwords="videomarkedwords" @keyup.enter="videosearchClick"></radius-input>
                    </div>

                          <div class="currentList">
                              <reportTable :data="data1" :head="head" :height="tH1" class="img-table" @showDetial="showDetials" ></reportTable>
                          </div>
                    <div class="historyList">
                          <!--<el-pagination small class="tiny-page"  layout="prev, pager, next" :total="30"></el-pagination>-->
                          <h2>| 历史检查</h2>
                      <div style="height:calc(100% - 40px);">
                        <reportTable :data="data2" :head="historyhead"  :readImageList="readImageList"  :showCheck="showCheck" :height="tH2" @showDetial="hisshowDetials"  @readImg="readImgs"> </reportTable>
                      </div>
                    </div>
                  </el-tab-pane>
                <!--病例-->
                  <el-tab-pane name="2">
                   <span slot="label">病例({{caseList.length}})</span>
                      <div style="height:40px; padding-top: 10px;">
                          <radius-input @searchClick="_openMedical" :markedwords="casemarkedwords" @keyup.enter="_openMedical"></radius-input>
                      </div>
                      <div class="medicalList">
                        <reportTable :head="medicalhead" :data="data3"  @showDetial="CaseshowDetials"></reportTable>
                      </div>
                  </el-tab-pane>

              </tabs>
         </div>
         <div class="layout-right">

            <!-- 影像 -->
              <div v-if="activeName === '1'" class="reportContent">
                <div class="cur-report" ref="curReport">
                  <h2>{{ ExamTypeName }}<span style="font-size:16px;font-weight:blod;">报告单</span>
                    <div class="report-btn">
                      <a v-for="(btnTxt,index) in btnTxts" href="javascript:;" @click="prepareAycan(btnTxt)" :class="{hui:index==1||index==0}">{{btnTxt}}</a>
                    </div>
                  </h2>
                    <reports :info="report" class="report"></reports>
                </div>
                <vue-scrollbar  class="checkDetails" ref="Scrollbar">
                  <div style="height:100%">
                      <div class="report-btn t10">
                        <!-- <a href="javascript:;" @click="hisprepareAycan()" >阅片</a> -->
                      </div>
                    <div class="result-con">
                      <div class="Image">
                        <span>| 影像所见</span>
                        <p class="content" v-show="currentRow!=null">{{currentRow.reportEvidences}}</p>
                      </div>

                      <div class="Result">
                        <span>| 诊断结果</span>
                        <p class="content" v-show="currentRow!=null">{{currentRow.reportConclusion}}</p>
                      </div>
                    </div>
                  </div>
                </vue-scrollbar>
              </div>

            <!-- 病例 -->
              <div v-if="activeName === '2'">
                  <!--<vue-scrollbar class="medical-content"  v-show="currentRow!=null" >-->
                    <tabs @tabChange="MTabChange" class="right-tab" :activeName="'0'">
                      <el-tab-pane v-for="tab in rightTabs" :label="tab.label" :name="tab.name" :key="tab.name" style="height: 100%;">

                        <!--病例信息-->
                        <div v-show="rightTabActive === '0'" class="blk">
                          <medicalNewsDetail :detailList="Casereport"></medicalNewsDetail>
                        </div>
                        <!--关联影像-->
                        <div v-show="rightTabActive === '1'" class="blk">
                          <p-table :head="studyhead" :data="data4" :autoheight="395"  :operation="operation" @_operation="_operation_"></p-table>
                        </div>
                        <!--病例附件-->
                        <div v-show="rightTabActive === '2'" class="blk">
                          <uploadDetail :updateFileList="updateFileList" :updatePicList="updatePicList"></uploadDetail>
                        </div>
                      </el-tab-pane>
                    </tabs>
                  <!--</vue-scrollbar>-->
              </div>
            <!-- 附件 -->
              <div  class="file_area" v-if="activeName === '0'" style="height:100%;">
                <div v-show="displayImg">
                     <img src="../../../../static/image/defaultpic.png" alt=""  height="140" />
                </div>
                <div v-if="imgShow=='1'" class="img_area">
                  <img width="80%" :src="fileUrl" alt="">
                </div>
                <div v-if="imgShow=='0'" class="file_show">
                  <p class="tip">暂不支持预览，请点击下载</p>
                  <a :href="fileUrl">下载</a>
                </div>
                <!--<iframe v-else ref="iframe" :src="fileUrl" frameborder="0" width="100%" height="100%" ></iframe>-->
              </div>
         </div>
    </div>


      <!-- pops -->
        <pops v-if="pop1" :show="pop1" :width="'980px'" :title="'从本院影像中选择'" @closePop="closePop" :class="'mrDialog'">
          <pImage :text="'加入读片队列'" @_popshow="popshow" @_popClose="popClose" :videosearchVal="videosearchVal"></pImage>
        </pops>
        <pops v-if="pop2" :show="pop2" :width="'980px'" :title="'从病例库中选择'" @closePop="closePop" :class="'mrDialog'">
          <div class="popScore popCourse queryCourse daily-pop2">
            <div class="popContent clearfix">
              <div class="leftCont medicalRecord_left">
                <div class="margin10_box medicalRecord_left">
                  <collapse-medical-record @tabChange="pubTabChange" :tabs="mtabs" @changeColl="changeColl"
                                           @delPerson="delPerson" @addPersonList="addPersonList" @personClick="personClick"
                                           @searchClick="searchClick" :personList="personList" :treeData="treeData"
                                           @treeNodeClick="treeNodeClick" :titleList="titleList" :filterText="filterText">
                  </collapse-medical-record>
                </div>
              </div>
              <div class="rightCont">
                <div class="rightTitle">
                  <span class="alreadyChoose">当前您已选择<i class="difColor">{{ CaseNum }}</i>条病例</span>
                  <div class="searchbar"> <radiusmedical-input @searchmediclClick="tableCaseList" ></radiusmedical-input></div>
                </div>
                <div class="borderCont">
                  <zTable :head="personTableHead" :data="tableData" :height="300" @tableVal="submitSelection" @ValLength="ValLength" ref="getSelection"></zTable>
                  <page :total="page.total" :currentPage="page.currentPage" @current-page="__currentPage"></page>
                </div>
              </div>
            </div>

              <btns :isAllowedClick="isAllowedClick" :text="'加入读片队列'" @clickbtn="Caseclickbtn"></btns>
               <fullscreen :loadingText="loadingText" :isFullscreen="isFullscreen"></fullscreen>
          </div>
        </pops>
        <pops :show="pop3" :width="'720px'" :title="'上传其他附件'" @closePop="closePop" :class="'mrDialog'">
          <div style="min-height:200px">
            <ul class="piclist" v-show="fileBool">
              <li v-for="(file,index) in FileList" :key="index" @click="finshed">
                <div v-show="true">
                  <i class="el-icon-circle-close" @click="removeFile(index,1)"></i>
                  <a style="display: inline-block; width: 100px; height: 100px; border: 1px solid #dbdbdb"><img :src="file.url" alt=""></a>
                  <b >{{file.attach_name}}</b>
                </div>
                <ProgressBar :step="steps" :initVal="initVal" :stopVal="stopVal" :isOk="isOk"
                             @callback="show"></ProgressBar>
              </li>
            </ul>
            <ul class="piclist" v-show="picBool">
              <li v-for="(file,index) in PicList" :key="index" @click="finshed">
                <div v-show="true">
                  <i class="el-icon-circle-close" @click="removeFile(index,2)"></i>
                  <a><img :src="file.url" alt=""></a>
                  <b>{{file.attach_name}}</b>
                </div>
                <ProgressBar :step="steps" :initVal="initVal" :stopVal="stopVal" :isOk="isOk"
                             @callback="show" ></ProgressBar>
              </li>
            </ul>
          </div>
           <btns :isAllowedClick="isAllowedClick" :text="'加入读片队列'" @clickbtn="_clickbtn" ></btns>
        </pops>

        <pops :show="pop4" @closePop="closePop" :width="popwidth" :title="title" :classes="'Collections'" class="collect">
          <elcRep :elcRep="elcRep"></elcRep>
        </pops>
        <aycanImages ref="aycanImages" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>
  </div>
</template>

<script type="text/ecmascript-6">
  import {nomalTime} from '@/common/js/time'
  import http from '@/api/http'
  import axios from 'axios'
  import * as _ from '@/common/js/config'
  import {cookies} from '@/api/util'
  import {message} from '@/common/js/messages'
  import tabs from '@/components/common/tabs/tabs'
  import reports from '@/components/common/report/publicReport'
  import reportTable from '@/components/common/tables/reportTable'
  import pTable from '@/components/common/tables/publicTable'
  import elcRep from '@/components/common/report/electronicReport'
  import medicalNewsDetail from '@/components/common/medicalNews/medicalNewsDetail'
  import uploadFile from '@/components/common/upload/uploadFile1'
  import uploadDetail from '@/components/common/upload/uploadDetail'
  import radiusInput from '@/components/common/radiusInput/radiusInput'
  import radiusmedicalInput from '@/components/common/radiusInput/radiusInput1'
  import ProgressBar from '@/components/common/upload/ProgressBar'
  import pImage from '@/components/common/Image/imageSelection'
  import btns from '@/components/common/button/buttons'
  import pops from '@/components/common/pops/pop'
  import page from '@/components/common/page/page'
  import zTable from '@/components/common/tables/table'
  import collapse from '@/components/common/collapse/collapse'
  import collapseMedicalRecord from '@/components/common/collapseMedicalRecord/collapseMedicalRecord'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import moment from 'moment'
  import VueScrollbar from 'vue2-scrollbar'
  import {changehosArea,changeAge,changeGender,changeSex,yinyang} from '@/common/js/change'
  import { setInterval, setTimeout } from 'timers';
  import aycanImages from '@/components/common/base/aycanImages'
  import fullscreen from '@/components/common/base/fullscreen'
  const btnTxts = ['查看申请单','电子病历', '阅片']

  export default {
    components: {
      tabs,
      radiusInput,
      radiusmedicalInput,
      ProgressBar,
      reports,
      collapseMedicalRecord,
      reportTable,
      pTable,
      medicalNewsDetail,
      uploadFile,
      VueScrollbar,
      collapse,
      page,
      btns,
      zTable,
      pImage,
      pops,
      uploadDetail,
      pops,
      elcRep,
      aycanImages,
      fullscreen
    },
    watch: {
      popShow(c) {
        this.getTableList()
      }
    },
    data() {
      return {
        interVal: '',
        Confid: '',//会议id
        thirdConfId: '',//第三方会议Id
        Confstatus: '',//会议状态
        memberCount: '',//参与人员个数
        qualityImagesList: [],//选择的影像数据
        severIds: [],//图片上传
        readImageList:[],
        filterText: '',//病例那块
        CaseNum: '',//弹窗中选中的病例个数
        CaseNumList: [],//表格中选择的病例
        activeName: '0',  //左侧tab对应右侧
        pubActive: '1',
        displayImg:true, //附件默认图片的显示
        showCheck: true,//显示勾选
        videomarkedwords: '请输入相应病案号/检查号',
        casemarkedwords: '输入相应关键字',
        collapseActive:['1','2'],
        rightTabActive: '0', //rigt
        getKeys:'',
        fileUrl:'',
        btnText:'开启视频',
        imgShow: '',
        popShow: true,
        isChecked:'0',
        width: 0,
        tH1: '100%',
        tH2: '100%',
        tH3: '100%',
        btnTxts: btnTxts,
        pop1: false,
        pop2: false,
        pop3:false,
        pop4:false,
        elcRep:{},
        popwidth:'',
        steps: 2,
        fileI:0,
        picI:0,
        initVal: 0,
        stopVal: 70,
        isOk: false,
        studyList:0,
        caseList:0,
        attachList:0,
        isFullscreen:false,//是否显示全屏遮罩
        loadingText:"提交中，请稍后.......",
        title:'',
        ExamTypeName: '', //报告单类型
        events:{  //会议标题
          title: '',
          confType: '',
          startTime:'',
          endTime:''
        },
        videoStart: {
          hospitalId: '',
          studyPk: '',
          studyUid: ''
        },
        hisvideoStart: {
          hospitalId: '',
          studyPk: '',
          studyUid: ''
        },
        attendList:[ //专家列表数据
          // {
          //   userId: '刘医生',
          //   docName: '刘医生'
          // }
        ],
        startT:'',
        myBarOptio:{
           barColor:"red"
        },
        report: {
        },
        Casereport: {},
        head: [ //影像表格头部
          {
            props: 'mediId',
            label: '病案号',
            columnWidth: 60
          },
          {
            props: 'patientAge',
            label: '年龄',
            columnWidth: 50
          },
          {
            props: 'patientSex',
            label: '性别',
            columnWidth: 50
          },
          {
            props: 'examTypeName',
            label: '类型',
            columnWidth: 50
          },
          {
            props: 'examBodyName',
            label: '检查项目',
            columnWidth: 90
          }
        ],
        studyhead: [ //影像表格头部
          {
            props: 'mediId',
            label: '病案号',
            columnWidth: 60
          },
          {
            props: 'patientAge',
            label: '年龄',
            columnWidth: 50
          },
          {
            props: 'patientSex',
            label: '性别',
            columnWidth: 50
          },
          {
            props: 'examTypeName',
            label: '类型',
            columnWidth: 50
          },
          {
            props: 'examBodyName',
            label: '检查项目',
            columnWidth: 90
          }
        ],
        historyhead: [
          {
            props: 'examDate',
            label: '检查时间',
            columnWidth: 125
          },
          {
            props: 'examTypeName',
            label: '类型',
            columnWidth: 55
          },
          {
            props: 'examBodyName',
            label: '检查项目',
            columnWidth: 120
          }
        ],
        medicalhead: [
          {
            props: 'caseName',
            label: '病例名称',
            columnWidth: 120
          },
          {
            props: 'caseSex',
            label: '性别',
            columnWidth: 60
          },
          {
            props: 'caseAge',
            label: '年龄',
            columnWidth: 60
          },
          {
            props: 'privateType',
            label: '权限',
            columnWidth: 60
          }
        ],
        personTableHead: [
          {
            props: 'caseName',
            label: '病例名称'
          },
          {
            props: 'caseSex',
            label: '性别'
          },
          {
            props: 'caseAge',
            label: '年龄'
          },
          {
            props: 'createDateStr',
            label: '创建时间'
          },
          {
            props: 'creatorName',
            label: '创建人'
          },
        ],
        data1: [ //影像数据
          // {
          //   medicalNumber: '474163',
          //   age: '18 岁',
          //   gender: '女',
          //   type: 'CT',
          //   checkItem: '头颅正侧位头颅正侧位'
          // }
        ],
        data2: [ //影像历史检查
          // {
          //   checkTime: '2017-09-09 12:25',
          //   type: 'DR',
          //   checkItem: '头颅正侧位头颅正侧位'
          // }
        ],
        data3:[
          // {
          //   medicalName: '心脏病和2',
          //   gender: '女',
          //   age: '25',
          //   publicity: '公开'
          // }
        ],
        data4:[

        ],
        tableData: [
          // {
          //   score: '淋巴肿瘤',
          //   sex: '男',
          //   pag: '25',
          //   classify: '2017-09-09 12:25',
          //   founder: '方孟伟'
          // }
        ],
        detail: {},
        currentRow: {
          reportEvidences: '',
          reportConclusion: ''
        },
        showCheckBox: false,
        operation: [
          {
            operation: '阅片',
            class: 'icon-yuepian'
          }
        ],
        tabs: [
          {label: '附件', name: '0'},
          {label: '影像', name: '1'},
          {label: '病例', name: '2'},

        ],
        titleList: [
          { title: "自定义分类", name: "4" },
          { title: "按诊断分类", name: "1" },
          { title: "按部位分类", name: "2" },
          { title: "按科室分类", name: "3" }
        ],
        isPerson: false,
        showCheckBox: false,
        fileBool: true,
        picBool: false,
        picI:0,
        fileI:0,
        personList: [
          // {label: '个人病例1'},
          // {label: '个人病例2'},
          // {label: '个人病例3'}
        ],
        mtabs: [
          {label: '公共分类', name: '0'},
          {label: '个人分类', name: '1'}
        ],
        allTreeData: [],
        treeData: [
          // {
          //   id: 1,
          //   label: '一级 2',
          //   children: [{
          //     id: 3,
          //     label: '二级 2-1'
          //   },{
          //     id: 2,
          //     label: '二级 2-2',
          //     disabled: true
          //   }]
          // }
        ],
        rightTabs: [
          {label: '病例信息', name: '0'},
          {label: '关联影像', name: '1'},
          {label: '病例附件', name: '2'}
        ],
        fileannex:[
          // {
          //   refId:'1854525',
          //   label:'课件名称1.pptx',
          //   filePathUrl:'http://o.officeweb365.com/p/pv.aspx?PowerPointView=ReadingView&WOPISrc=http%3A%2F%2Fow365%2Fwopi%2Ffiles%2F%40%2Fwopi%3FvId%3DhZXiYjJc3VEBIPnKQhZw6w%3D%3D&bs=b2ZmaWNld2ViMzY1LmNvbS44MFzmipXotYTorqHliJLnu5@orqHkuI7nrqHnkIbvvIjljZfkuqzlj5HlsZXmlLnpnanorqHliJLmipXotYTlpITvvIkucHB0eA==&token=pEmdJmSp_ClEVTDixvljrdMfFz1NcqYW&cancopy='
          // }
        ],
        picannex:[
          // {
          //   refId:'1854525',
          //   label:'课件名称1.pptx',
          //   filePathUrl:'http://o.officeweb365.com/p/pv.aspx?PowerPointView=ReadingView&WOPISrc=http%3A%2F%2Fow365%2Fwopi%2Ffiles%2F%40%2Fwopi%3FvId%3DhZXiYjJc3VEBIPnKQhZw6w%3D%3D&bs=b2ZmaWNld2ViMzY1LmNvbS44MFzmipXotYTorqHliJLnu5@orqHkuI7nrqHnkIbvvIjljZfkuqzlj5HlsZXmlLnpnanorqHliJLmipXotYTlpITvvIkucHB0eA==&token=pEmdJmSp_ClEVTDixvljrdMfFz1NcqYW&cancopy='
          // }
        ],
        FileList: [],
        PicList: [],
        updatePicList:[],
        updateFileList:[],
        medicalVal: '',
        videosearchVal: '',
        userName: '',//登录用户的信息
        fileType: ['.ppt','.pptx', '.pdf','.doc', '.docx','.rtf','.xls'],
        picType:['.jpg', '.png','.gif','.bmp'],
        page: {
          total: 0,
          currentPage: 0,
          pageSize: 10
        },
        isAllowedClick:true,
        params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        },
        checkList: {
          hospitalId: '',
          studyPk:'',
          studyUid: ''
        },
      }
    },
    beforeMount() {
      //设置定时器，每5秒刷新一次
      var self = this
      if(self.Confstatus != '1' && self.Confstatus != '2') {
        self.interVal = setInterval(updateConfMember,5000)
      }
      function updateConfMember() {
        let Memberparams = {
          status: self.Confstatus,
          id: self.Confid
        }
        http.post('/conference/heartConfMember.json', Memberparams).then(res => {
          if (res.data.code === _.ERR_OK) {
            let attendListVal= []
            // console.log(attendListVal)
            http.post('/conference/getDailyConfMemberList.json', {"id": self.Confid }).then(res => {
              if (res.data.code === _.ERR_OK) {
                for(let item of res.data.model) {
                  attendListVal.push({
                    userId: item.userId,
                    docName: item.docName
                  })
                }
              }
              // console.log(attendListVal)
              self.attendList = attendListVal
            }).catch(() => {

            })
            http.post('/conference/getDailyConfMemberCount.json', {"id": self.Confid }).then(res => {
              if (res.data.code === _.ERR_OK) {
                let memberCountVal = ''
                memberCountVal = res.data.model
                // console.log(memberCountVal)
                self.memberCount = memberCountVal
              }
            }).catch(() => {

            })
          }
        }).catch(() => {

        })
      }
    },
    beforeRouteLeave(to, form, next) { //离开页面时关闭定时器
      clearInterval(this.interVal)
      next()
    },
    mounted() {
    },
    methods: {

      //历史检查列表的勾选
     readImgs(val){
       this.currentRow = val;
       this.readImageList=val;
       //console.log(val,'llll')
       for(let i=0;i<this.currentRow.length;i++){
          this.checkList.hospitalId=this.currentRow[i].hospitalId;
          this.checkList.studyPk= this.currentRow[i].studyPk;
          this.checkList.studyUid= this.currentRow[i].studyUid;
       }
        let params={
         hospitalId:this.checkList.hospitalId,
         studyPk:this.checkList.studyPk,
         studyUid: this.checkList.studyUid
      }

       http.post('/edu/ourHosReportDeatil.json', params).then(res => {
           if (res.data.code == "0000") {
            this.currentRow.studiesDoneDt=nomalTime(res.data.model.studiesDoneDt)
            this.currentRow=res.data.model
           }else{
            this.currentRow={}
           }
         }).catch(() => {
       })
     },
        showDetials(val) {
        // console.log('影像切换')
        // console.log(val)
        this.report = {}
        this.currentRow.reportConclusion = ''
        this.currentRow.reportEvidences = ''
        this.ExamTypeName = ''
        this.videoStart.hospitalId = val.hospitalId
        this.videoStart.studyPk = val.studyPk
        this.videoStart.studyUid = val.studyUid
        this.data2 =[]
        if(val.reportState != '3') {
          message('该影像无报告',false)
          return false
        }
        //获取报告单详情
        let rep = {
          hospitalId: val.hospitalId,
          studyPk: val.studyPk,
          studyUid: val.studyUid,
        }
        http.post('/edu/reportDetail.json', rep).then(res => {
          // console.log(res.data)
          if (res.data.code == "0000") {
            res.data.model.studiesDoneDt = nomalTime(res.data.model.studiesDoneDt)
            res.data.model.reportSdt = nomalTime(res.data.model.reportSdt)
            res.data.model.approveDt = nomalTime(res.data.model.approveDt)
            res.data.model.reviseTime = nomalTime(res.data.model.reviseTime)
            res.data.model.patientSex = changeGender(res.data.model.patientSex)
            res.data.model.masculineFlag = yinyang(res.data.model.masculineFlag)
            if(res.data.model.patientAge == undefined) {
               res.data.model.patientAge = ''
            }else if(res.data.model.patientAge.indexOf("岁")>0){
               res.data.model.patientAge = res.data.model.patientAge
            }
             else {
                res.data.model.patientAge = res.data.model.patientAge + changeAge(res.data.model.ageUnit)
            }
            this.report= res.data.model
            this.ExamTypeName = res.data.model.examTypeName
            sessionStorage.setItem('zerRep',JSON.stringify(this.report))
          }
        }).catch(() => {
        })
        //获取历史列表
        let hisparam = {
          hospitalId: val.hospitalId,
          studyPk: val.studyPk,
        }
        http.post('/edu/historyCheckList.json', hisparam).then(res => {
          // console.log(res.data)
          if (res.data.code == "0000") {
            this.data2 = [];
            for (let i = 0; i < res.data.model.length; i++) {
              res.data.model[i].examDate = nomalTime(res.data.model[i].examDate).slice(0,nomalTime(res.data.model[i].examDate).indexOf(' '))
              res.data.model[i].reportSdt = nomalTime(res.data.model[i].reportSdt);
              res.data.model[i].approveDt = nomalTime(res.data.model[i].approveDt);
              res.data.model[i].reviseTime = nomalTime(res.data.model[i].reviseTime);
              this.data2.push(res.data.model[i]);
            }
          }
        }).catch(() => {
        });
      },
         //阅片
      prepareAycan(val) {
        //console.log(this.readImageList)
        // console.log(val)
        if(val == '阅片') {
          const hospitalIdList=[];
          const studyPkList=[];
          const studyUidliset=[];
         // console.log(this.readImageList.length,'lldggg')
        if(this.readImageList.length>0){
          this.readImageList.forEach(item => {
          hospitalIdList.push(item.hospitalId);
          studyPkList.push(item.studyPk);
          studyUidliset.push(item.studyUid);
        });
        this.params_image.hospitalId =hospitalIdList.join(",")+','+this.videoStart.hospitalId;
        this.params_image.studyPk = studyPkList.join(",")+','+this.videoStart.studyPk+"";
        this.params_image.studyUid =  studyUidliset.join(",")+','+this.videoStart.studyUid;
        this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
        })
       }else{this.params_image.hospitalId =this.videoStart.hospitalId;
            this.params_image.studyPk = this.videoStart.studyPk+"";
            this.params_image.studyUid = this.videoStart.studyUid;
            this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
         })
       }


            // let Aycan = {
            //   hospitalId:this.videoStart.hospitalId,
            //   studyPk:this.videoStart.studyPk,
            //   studyUid:this.videoStart.studyUid,
            // }
            // http.post('/edu/prepareAycan.json', Aycan).then(res => {
            //   if (res.data.code === "0000") {
            //     let url = res.data.model
            //     window.open(url,'_blank')
            //   }else{
            //     message('影像调阅失败',false);
            //   }
            // }).catch(() => {
            // })
        } else if (val == '查看申请单') {
           return
        } else {
          message('该功能未开启',true)
        }
      },

      //历史阅片
      // hisprepareAycan() {
      //   this.params_image.hospitalId =this.hisvideoStart.hospitalId;
      //   this.params_image.studyPk = this.hisvideoStart.studyPk+"";
      //   this.params_image.studyUid = this.hisvideoStart.studyUid;
      //   this.$nextTick(() => {
      //     this.$refs.aycanImages.getConsultImages();
      //   })
        // let Aycan = {
        //   hospitalId:this.hisvideoStart.hospitalId,
        //   studyPk:this.hisvideoStart.studyPk,
        //   studyUid:this.hisvideoStart.studyUid,
        // }
        // http.post('/edu/prepareAycan.json', Aycan).then(res => {
        //   if (res.data.code === "0000") {
        //     let url = res.data.model
        //     window.open(url)
        //   }else{
        //     message('该病人无初始影像',false);
        //   }
        // }).catch(() => {
        // })
     // },
      getParams() {
        // 取到路由带过来的参数
        let routerParams = this.$route.params.dataobj
        // 将数据放在当前组件的数据内
        this.msg = routerParams
      },
      stepMove(num) {
        this.activeName = (this.activeName - 0 + num).toString()
        this.rightTabActive = (this.rightTabActive - 0 + num).toString()
      },
      formatTime(events){
      },
      NewConfmenber() {
        let Memberparams = {
          status: this.Confstatus,
          id: this.Confid
        }
        http.post('/conference/heartConfMember.json', Memberparams).then(res => {
          // console.log('新增会议的参与人员')
          // console.log(res)
          if (res.data.code === _.ERR_OK) {
            // console.log(res.data.model)
            http.post('/conference/getDailyConfMemberList.json', {"id": this.Confid }).then(res => {
              // console.log('参与人员')
              // console.log(res)
              this.attendList = []
              if (res.data.code === _.ERR_OK) {
                for(let item of res.data.model) {
                  this.attendList.push({
                    userId: item.userId,
                    docName: item.docName
                  })
                }
              }
            }).catch(() => {

            })
            http.post('/conference/getDailyConfMemberCount.json', {"id": this.Confid }).then(res => {
              // console.log('参与人数')
              // console.log(res)
              if (res.data.code === _.ERR_OK) {
                this.memberCount = res.data.model
              }
            }).catch(() => {

            })
          } else  {
            // message(res.data.msg, true)
            http.post('/conference/getDailyConfMemberList.json', {"id": this.Confid }).then(res => {
              // console.log('参与人员')
              // console.log(res)
              this.attendList = []
              if (res.data.code === _.ERR_OK) {
                for(let item of res.data.model) {
                  this.attendList.push({
                    userId: item.userId,
                    docName: item.docName
                  })
                }
              }
            }).catch(() => {

            })
            http.post('/conference/getDailyConfMemberCount.json', {"id": this.Confid }).then(res => {
              // console.log('参与人数')
              // console.log(res)
              if (res.data.code === _.ERR_OK) {
                this.memberCount = res.data.model
              }
            }).catch(() => {

            })
          }
        }).catch(() => {

        })
      },
      _operation_(payload) { //关联影像操作
        if (payload.operation === 'icon-yuepian') {
          this.params_image.hospitalId =this.data4[payload.index].hospitalId;
          this.params_image.studyPk = this.data4[payload.index].studyPk+"";
          this.params_image.studyUid = this.data4[payload.index].studyUid;
          this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
            })
          // let Aycan = {
          //   hospitalId:this.data4[payload.index].hospitalId,
          //   studyPk:this.data4[payload.index].studyPk,
          //   studyUid:this.data4[payload.index].studyUid,
          // }
          // http.post('/edu/prepareAycan.json', Aycan).then(res => {
          //   if (res.data.code == "0000") {
          //     window.open(res.data.model,'_blank');
          //   }else{
          //     message('该病人无初始影像',false);
          //   }
          // }).catch(() => {
          // })
        }
      },
      videosearchClick(payload) {
        // console.log(payload)
        if(this.Confstatus == '1' || this.Confstatus == '2') {
          this.pop1 = false
          message('该会议已过期或已结束',false)
        } else {
          this.videosearchVal = payload
          // saveLocalStorage(this.videosearchVal, 'videosearchVal')
          // console.log(this.videosearchVal)
          this.pop1 = true
        }
      },
      _openMedical(payload) {
        // console.log(payload)
        if(this.Confstatus == '1' || this.Confstatus == '2') {
          this.pop2 = false
          message('该会议已过期或已结束',false)
        } else {
          this.medicalVal = payload
          saveLocalStorage(this.medicalVal, 'medicalVal')
          this.getTableList()
          this.pop2 = true
        }
      },
      closePop(payload) {
        this.pop1 = payload
        this.pop2 = payload
        this.pop3 = payload
      },
      tabChange(payload) {
        this.activeName = payload.name
        this.$emit('tabChange', payload)
      },
      pubTabChange(payload) {
        this.filterText = ''
        this.personFlag = payload.name
        // console.log(this.oldPersonList)
        this.personList = this.oldPersonList
        if (payload.name === "1") {
          this.isPerson = true;
          this.showCheckBox = true;
        } else {
          this.isPerson = false;
          this.showCheckBox = false;
        }
        this.getTableList(payload.name)
        this._getTreeData()
      },
      _getTreeData(privateType = 0, keyWord='', subType) {
        let parmars = {
          privateType,
          keyWord,
          subType
        };
        http.post("/catalog/queryCaseCatalogTree.json", parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            if (privateType === 0) {
              this.allTreeData = res.data.model
              this.changeColl('1')
            } else {
              this.oldPersonList = res.data.model
              this.personList = res.data.model
            }
          }
        })
      },
      changeColl(playlod) {
        // 1==>部位 2==>诊断 3==>科室
        let [flag, arr] = ['DIANOG', []];
        if (playlod === '1') {
          flag = 'DIANOG';
        } else if (playlod === '2') {
          flag = 'PART';
        } else if (playlod === '3') {
          flag = 'DEPT';
        } else {
          flag = 'CUSTOMER';
        }
        this.treeData = []
        arr = this.allTreeData.filter(item => item.subType === flag)
        for (let item of arr) {
          if (item.parentId === 0) {
            this.treeData.push({
              id: item.id,
              label: item.catalogName,
              children: this.allTreeData.filter(c => c.parentId ===  item.id)
            })
          }
        }
        for (let item of this.treeData) {
          if (item.children.length > 0) {
            for (let cItem of item.children) {
              cItem.label = cItem.catalogName
            }
          }
        }
      },
      delPerson(val) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          let parmars = {
            id: val.id
          }
          http.post('catalog/deleteCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      addPersonList(val) {
        this.$prompt('请输入病例名', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
          // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          // inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          let parmars = {
            privateType: '1',
            catalogName:　value
          }
          http.post('catalog/addCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '提交成功'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      personClick(val) {
        this.getTableList(this.personFlag, val.id)
      },
      treeNodeClick(val) {
        this.getTableList(this.personFlag, val.id)
      },
      searchClick(val) {
        this.filterText = val
        if (this.isPerson) {
          this.personList = this.oldPersonList.filter(item => item.catalogName.includes(val))
        } else {
          // 公共的搜索功能
        }
      },
      getTableList(privateType=0,catalogId) {
        let parmars = {}
        // console.log(this.medicalVal)
        if(this.medicalVal) {
           parmars = Object.assign({
            catalogId,
            privateType,
            keyWord: this.medicalVal
          }, this.page)
          this.medicalVal = ''
        } else {
           parmars = Object.assign({
            catalogId,
            privateType,
            keyWord: this.tableKeyWords
          }, this.page)
        }
        http.post('caselib/queryCaseList.json', parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.tableData = res.data.model
            this.page.total = res.data.totalItem
            this.page.currentPage = res.data.currentPage
            for (let item of this.tableData) {
              item.caseSex = _.SEXOBJ[item.caseSex]
              item.privateType = _.privateType[item.privateType]
              if(item.caseAge !== undefined) {
                item.caseAge = item.caseAge + changeAge(item.ageUnit)
              } else {
                item.caseAge = ''
              }
              if (item.caseSex === '1') {
                this.detail.caseSex = '男'
              } else {
                this.detail.caseSex = '女'
              }
            }

          }
        })
      },
      tableCaseList(val) {
        this.tableKeyWords = val
        this.getTableList()
      },
      __currentPage(val) {
        this.page.currentPage = val
        this.getTableList()
      },
      submitSelection(val){
        // console.log(val)
        this.CaseNumList = val
      },
      ValLength(val) {
        this.CaseNum = val
      },
      MTabChange(payload){
        this.rightTabActive = payload.name
      },
      rightTabChange(payload) {
        // console.log(payload)
        this.activeName = payload.name
        this.rightTabActive = payload.name
      },
      // getFileVal() {
        // let params = {
        //   refId: this.Casereport.id,
        //   businessType: 'conference'
        // }
        // http.post('system/getRelateAttachList.json', params).then(res => {
        //   if (res.data.code === _.ERR_OK) {
        //     for (let item of res.data.model) {
        //       if (item.attach_type === 'file') {
        //         this.updateFileList = [item]
        //       } else {
        //         this.updatePicList = [item]
        //       }
        //     }
        //   } else {
        //   }
        // })
      // },
      hisshowDetials(val) {
        // console.log('历史影像切换')
        // console.log(val)
        let param = {}
        this.currentRow.reportConclusion = ''
        this.currentRow.reportEvidences = ''
        param.hospitalId = val.hospitalId
        param.studyPk = val.studyPk
        param.studyUid = val.studyUid
        this.hisvideoStart.hospitalId = val.hospitalId
        this.hisvideoStart.studyPk = val.studyPk
        this.hisvideoStart.studyUid = val.studyUid
        //console.log(this.currentRow)
        http.post('/edu/reportDetail.json', param).then(res => {
          if (res.data.code == "0000") {
            this.currentRow.reportConclusion = res.data.model.reportConclusion
            this.currentRow.reportEvidences = res.data.model.reportEvidences
          }
        }).catch(() => {
        })

      },
      //病例详情
      CaseshowDetials(val) {
        // console.log('病例详情切换')
        // console.log(val)
        this.updateFileList = []
        this.updatePicList = []
        http.post('/caselib/getCaseDetail.json', {'id' : val.id}).then(res => {
          if (res.data.code === _.ERR_OK) {
            // console.log(res.data.model)
            this.detail = res.data.model
            this.page.total = res.data.totalItem
            this.page.currentPage = res.data.currentPage
            if(this.detail.caseAge !== undefined) {
              this.detail.caseAge = this.detail.caseAge + changeAge(this.detail.ageUnit)
            } else {
              this.detail.caseAge = ''
            }
            // for (let item of this.tableData) {
            //   item.caseSex = _.SEXOBJ[item.caseSex]
            //   item.privateType = _.privateType[item.privateType]
            //   if (item.caseSex === '1') {
            //     this.detail.caseSex = '男'
            //   } else {
            //     this.detail.caseSex = '女'
            //   }
            // }
            if(this.detail.caseSex == '0') {
              this.detail.caseSex = '女'
            } else {
              this.detail.caseSex = '男'
            }
              // this.detail.caseSex = this.item.caseSex

            this.Casereport = this.detail
            for(let item of this.detail.studyList) {
              if(item.patientSex == 'F') {
                item.patientSex = '女'
              } else {
                item.patientSex = '男'
              }
            }
         //   console.log(this.detail.studyList)
            for(let item of this.detail.studyList) {
              if(item.patientAge == undefined) {
                 item.patientAge = ''

              }else if( item.patientAge.indexOf("岁")>0){
                item.patientAge = item.patientAge
              }
              else {
                item.patientAge = item.patientAge + changeAge(item.ageUnit)
              }
            }
            this.data4 = this.detail.studyList
            if (this.detail.attachList.length > 0) {
              for (let item of this.detail.attachList) {
                if (item.attach_type === 'file') {
                  this.updateFileList.push(item)
                } else {
                  this.updatePicList.push(item)
                }
              }
            }
          }
        })
      },
      //上传功能
      addFile(val) {
        // console.log(val)
        if(val == '1') {
          this.fileBool = true
          this.picBool = false
        } else if(val == '2') {
          this.fileBool = false
          this.picBool = true
        }
        this.pop3 = true
      },
      finshed(){

        this.isOk = false;
      },
      show(val) {
        if (val == "success") {
          this.isOk = true;
          /*setTimeout(()=>{
            this.showimg = true;
          },200)*/
        }
      },
      changeFn(e, type) {
        if(this.Confstatus == '1' || this.Confstatus == '2') {
          message('该会议已过期或已结束',false)
        } else {
          let list
          type == 1 ? list = this.FileList : list = this.PicList
          if (list.length > 10) {
            alert('最多只能上传10个附件')
            return false
          }

          let deviceFile = e.target.files
          let formData = new FormData()
          list.push({
            attach_name: deviceFile[0].name,
            url: ''
          })
          let ext = deviceFile[0].name.slice(deviceFile[0].name.lastIndexOf(".") + 1)
          if (type === 1) {
          if (deviceFile[0].type.indexOf('image') > -1) {
            alert('支持30M以内.pptx/.docx/.pdf/.xlsx课件格式')
            list.splice(list.indexOf(deviceFile[0]), 1)
            e.target.value=''
            return false
          }
        } else {
          if (!(deviceFile[0].type.indexOf('image') > -1)) {
            alert('3M以内.jpg/.png/.bmp/.gif格式图片与预览')
            list.splice(list.indexOf(deviceFile[0]), 1)
            e.target.value=''
             this.showCheckBox = false;
            return false
          }
        }
          formData.append('attachement', deviceFile[0])
          e.target.value=''
          this.isAllowedClick = false;
          this.fullscreen=true
          axios.post(`${window.BASE_URL}system/uploadAttachement.json`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
            if (res.data.code === _.ERR_OK) {
                this.isAllowedClick = true;
                this.fullscreen=false;
              if (res.data.model.fileType === 'file') {
                if (res.data.model.fileSize / (1024 * 1024) > 30) {
                  alert('上传的文件大小不能超过30MB')
                  e.target.value=''
                  return false
                }
              } else {
                if (res.data.model.fileSize / (1024 * 1024) > 3) {
                  alert('上传的文件大小不能超过3MB')

                  e.target.value=''
                  return false
                }
              }
              // console.log(res.data.model)
              this.severIds.push(res.data.model)
              list[list.length - 1].url = res.data.model.filePathUrl
              // list[list.length - 1].url = res.data.model.filePathUrl
              list[list.length - 1].fileid = res.data.model.filerServerID
              list[list.length - 1].attach_size = res.data.model.fileSize
              list[list.length - 1].attach_type = res.data.model.fileType
              this.isOk = !this.isOk;
              this.$emit('fileChange', list)
            } else {
              if (type === 1) {
                this.$message.error('支持30M以内.pptx/.docx/.pdf/.xlsx课件格式')
              } else {
                this.$message.error('支持3M以内.jpg/.png/.bmp/.gif格式图片')
                this.PicList=''
              }
            }
            // console.log(ext)
            if (ext == 'xls') { //判断类型显示图标
              list[list.length - 1].url = '../../../../static/image/xlsicon.png'
            } else if (ext == 'doc' || ext == 'rtf' || ext == 'docx' ) {
              list[list.length - 1].url = '../../../../static/image/docicon.png'
            } else if (ext == 'pdf') {
              list[list.length - 1].url =  '../../../../static/image/pdficon.png'
            } else if (ext == 'ppt' || ext == 'pptx') {
              list[list.length - 1].url = '../../../../static/image/ppticon.png'
            } else {
              list[list.length - 1].url = res.data.model.filePathUrl
            }
          })
        }
      },
      fileJudge(ofile) {
        var ext = ofile.name.slice(ofile.name.lastIndexOf(".") + 1).toLowerCase();
        if (ext == 'xls') { //判断类型显示图标
          return '/';
        } else if (ext == 'doc') {
          return '/';
        } else if (ext == 'pdf') {
          return '/';
        } else if (ext == 'ppt') {
          return '/';
        } else if (ext == 'wps') {
          return '/';
        } else {
          return window.URL.createObjectURL(ofile);
        }
      },
      removeFile(index, type) {
        this.$confirm('确定要删除该附件吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          type == 1 ? this.FileList.splice(index, 1) : list = this.PicList.splice(index, 1);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
        // type == 1 ? this.FileList.splice(index, 1) : list = this.PicList.splice(index, 1);
      },
      _clickbtn(payload) {//附件上传加入读片列表
        if(payload == false) {
          this.pop3 = false
          this.PicList = []
          this.FileList = []
        } else if(payload && this.picBool) {
          // console.log(this.PicList)
          let fileList = []
          for(let item of this.PicList) {
            fileList.push({
              fileid: item.fileid,
              attach_name: item.attach_name,
              attach_type: item.attach_type,
              atatch_size: item.attach_size
            })
          }
          http.post('/system/relateFileToBuse.json', {fileList, "refId": this.Confid, "businessType": 'conference'}).then(res => {
            // console.log('加入读片列表')
            // console.log(res)
            if (res.data.code === _.ERR_OK) {
              message(res.data.msg, true)
              this.pop3 = false
              for(let item of this.PicList) {
                this.picannex.push({
                  refId: item.fileid,
                  label: item.attach_name,
                  filePathUrl: item.url,
                  attach_type: item.attach_type
                })
              }
              this.PicList = []
              history.go(0)
            }
          }).catch(() => {

          })
        } else if(payload && this.fileBool) {
          // console.log(this.FileList)
          let fileList = []
          for(let item of this.FileList) {
            fileList.push({
              fileid: item.fileid,
              attach_name: item.attach_name,
              attach_type: item.attach_type,
              atatch_size: item.attach_size
            })
          }
          http.post('/system/relateFileToBuse.json', {fileList, "refId": this.Confid, "businessType": 'conference'}).then(res => {
            // console.log('加入读片列表')
            // console.log(res)
            if (res.data.code === _.ERR_OK) {
              message(res.data.msg, true)
              this.pop3 = false
              for(let item of this.FileList) {
                this.fileannex.push({
                  refId: item.fileid,
                  label: item.attach_name,
                  filePathUrl: item.url,
                  attach_type: item.attach_type
                })
              }
              this.FileList = []
              history.go(0)
            }
          }).catch(() => {

          })
        }
      },
      Caseclickbtn(payload) { //病例加入列表
        this.$refs.getSelection.getList();
        if(payload == false) {
          this.pop2 = false
        } else if(payload) {
          // console.log(payload)
          // this.data3 = []
          //新增病例
          let caseList = []
          for(let item of this.CaseNumList) {
            caseList.push({
              caseId: item.id
            })
          }
          http.post('/system/relateCaseToBuse.json', {caseList, "refId": this.Confid, "businessType": 'conference'}).then(res => {
            // console.log('新增病例')
            // console.log(res)
            if (res.data.code === _.ERR_OK) {
              message(res.data.msg, true)
              this.pop2 = false
              //查询业务关联的病例列表
              let caseListparams = {
                refId: this.Confid,
                businessType: 'conference'
              }
              http.post('/system/getRelateCaseList.json', caseListparams).then(res => {
                // console.log('关联的病例列表')
                // console.log(res)
                this.data3 = []
                if (res.data.code === _.ERR_OK) {
                  for(let item of res.data.model) {
                    let SexVal = ''
                    if(item.caseSex == '0') {
                      SexVal = '女'
                    } else {
                      SexVal = '男'
                    }
                    let privateTypeVal = ''
                    if(item.privateType == '0') {
                      privateTypeVal = '公共'
                    } else if(item.privateType == '1') {
                      privateTypeVal = '个人'
                    } else if(item.privateType == '2') {
                      privateTypeVal = '部门公开'
                    } else {
                      privateTypeVal = '医院公开'
                    }
                    let caseAge = ''
                    if(item.caseAge !== undefined) {
                      caseAge = item.caseAge + changeAge(item.ageUnit)
                    } else {
                      caseAge = ''
                    }
                    this.data3.push({
                      caseName: item.caseName,
                      caseSex: SexVal,
                      caseAge: caseAge,
                      privateType: privateTypeVal,
                      id: item.id
                    })
                  }
                  history.go(0)
                }
              }).catch(() => {

              })
              // for(let item of this.CaseNumList) {
              //   this.data3.push({
              //     caseName: item.caseName,
              //     caseSex: item.caseSex,
              //     caseAge: item.caseAge,
              //     privateType: item.privateType,
              //     id: item.id
              //   })
              // }
            }
          }).catch(() => {

          })
        }
      },
      //iframe 预览
      // chosefile(fj,index){
      //   this.isChecked = index
      //   this.fileUrl = fj.filePathUrl
      // },
      // chosepic(fj,index){
      //   this.isChecked = index
      //   this.fileUrl = fj.filePathUrl
      // },
      fileCLick(type, obj, index) {
        if(type==='file'){
          this.fileI = index
          this.picI = null
        } else {
          this.fileI = null
          this.picI = index
        }
        let params = {
          refId: this.Confid,
          businessType: 'conference'
        }
        // console.log(obj)
        http.post('/system/getRelateAttachList.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            if (obj.attach_type === 'file') {
                this.displayImg=false
              for (let item of res.data.model) {
                if (item.fileid === obj.refId) {
                  //this.fileUrl = encodeURI(`https://ow365.cn/?i=15894&furl=${item.fileurl}`)
                  this.imgShow = '0'
                  this.fileUrl = encodeURI(encodeURI(item.fileurl));
                }
              }
            } else {
              for (let item of res.data.model) {
                  this.displayImg=false
                if (item.fileid === obj.refId) {
                  this.fileUrl = item.fileurl
                  this.imgShow = '1'
                }
              }
            }
          }
        })
      },
      handleRemove(file, fileList) {
        // console.log(file, fileList)
      },
      handlePreview(file) {
        // console.log(file)
      },
      handled(index) {
        this.selected = index
      },
      popshow(payload) { //确定，关闭影像弹窗
        // this.data1 = []
        this.qualityImagesList = payload
        // console.log(this.qualityImagesList)
        //新增关联影像
        let studyList = []
        for(let item of this.qualityImagesList) {
          studyList.push({
            hospitalId: item.hospitalId,
            studyPk: item.studyPk
          })
        }
        http.post('/system/relateStudyToBuse.json', {studyList, "refId": this.Confid, "businessType": 'conference'}).then(res => {
          // console.log('新增关联影像')
          // console.log(res)
          if (res.data.code === _.ERR_OK) {
            message(res.data.msg, true)
            this.pop1 = false
            //查询业务关联的影像列表
            let studyListparam = {
              refId: this.Confid,
              businessType: 'conference'
            }
            http.post('/system/getRelateStudyList.json', studyListparam).then(res => {
              // console.log('关联的影像列表')
              // console.log(res)
              this.data1 = []
              if (res.data.code === _.ERR_OK) {

                for(let item of res.data.model) {
                  let ageVal = ''
                  if(item.patientSex == 'F') {
                    ageVal = '女'
                  } else {
                    ageVal = '男'
                  }
                  let caseAge = ''
                  if(item.patientAge == undefined) {
                     caseAge = ""
                  }else if(item.patientAge.indexOf("岁") >0){
                    caseAge = item.patientAge
                  }
                  else {
                    caseAge = item.patientAge + changeAge(item.ageUnit)
                  }
                  this.data1.push({
                    mediId: item.mediId,
                    patientAge: caseAge,
                    patientSex: ageVal,
                    examTypeName: item.examTypeName,
                    examBodyName: item.examBodyName,
                    hospitalId: item.hospitalId,
                    studyPk: item.studyPk,
                    studyUid: item.studyUid,
                    reportState: item.reportState
                  })
                }
                history.go(0)
              }
            }).catch(() => {

            })
          }
        }).catch(() => {

        })

      },
      popClose() {
        this.pop1 = false
      },
      startConfView() { //开启视频
        let startViewJson = {
          id: this.Confid,
          confId: this.thirdConfId
        }
        http.post('/conference/startDailyConfView.json', startViewJson).then(res => {
          // console.log('开启视频')
          // console.log(res)
          if (res.data.code === _.ERR_OK) {
            // console.log(this.userName)
            let txtServerAddress = '114.55.29.216' //服务器地址
            let txtServerPort = '17979' //服务器端口
            let txtUserNickname = this.userName  //用户昵称
            let txtConfID = this.thirdConfId //会议ID
            let jsonText = this.getJsonTextDirectEnterConf(txtServerAddress, txtServerPort,
              txtUserNickname, txtConfID)

            // console.log(jsonText)
            let jsonTextBase64 = this.base64encode(this.utf16to8(jsonText))
            this.executeAction(jsonTextBase64)
          } else {
            message(res.data.msg,false)
          }
        }).catch(() => {

        })

      },
      getJsonTextDirectEnterConf(serverAddress, serverPort, userNickname, confID) {
        var jsonText = '{' +
          '"Server": {' +
          '"Address": "' + serverAddress + '",' +
          '"Port": ' + serverPort +
          '},' +
          '"Action": {' +
          '"Name": "DirectEnterConf",' +
          '"Parameters": {' +
          '"UserName": "' + this.encodeUTF8(userNickname) + '",' +
          '"ConfID": ' + confID +
          '}' +
          '}' +
          '}'
        // console.log(jsonText)
        return jsonText
      },
      encodeUTF8(str) {
        var temp = "",rs = "";
        for( var i=0 , len = str.length; i < len; i++ ){
          temp = str.charCodeAt(i).toString(16);
          rs  += "\\u"+ new Array(5-temp.length).join("0") + temp;
        }
        return rs;
      },
      utf16to8(str) {
        var out, i, len, c;

        out = "";
        len = str.length;
        for (i = 0; i < len; i++) {
          c = str.charCodeAt(i);
          if ((c >= 0x0001) && (c <= 0x007F)) {
            out += str.charAt(i);
          } else if (c > 0x07FF) {
            out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
            out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
          } else {
            out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
          }
        }
        return out;
      },
      base64encode(str) {
        var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var out, i, len;
        var c1, c2, c3;

        len = str.length;
        i = 0;
        out = "";
        while (i < len) {
          c1 = str.charCodeAt(i++) & 0xff;
          if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt((c1 & 0x3) << 4);
            out += "==";
            break;
          }
          c2 = str.charCodeAt(i++);
          if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt(((c1 & 0x3) << 4)
              | ((c2 & 0xF0) >> 4));
            out += base64EncodeChars.charAt((c2 & 0xF) << 2);
            out += "=";
            break;
          }
          c3 = str.charCodeAt(i++);
          out += base64EncodeChars.charAt(c1 >> 2);
          out += base64EncodeChars.charAt(((c1 & 0x3) << 4)
            | ((c2 & 0xF0) >> 4));
          out += base64EncodeChars.charAt(((c2 & 0xF) << 2)
            | ((c3 & 0xC0) >> 6));
          out += base64EncodeChars.charAt(c3 & 0x3F);
        }
        return out;
      },
      executeAction(jsonTextBase64) {
        var theResult = -1;
        jQuery.ajax(
          {
            type: "GET",
            url: "http://127.0.0.1:17979/IMConf",
            data: "URL=IMConf://" + jsonTextBase64 + "/",
            dataType: "jsonp",
            //async: false,
            jsonp: "jsonpCallback",
            success: function (data) {
              // console.log('成功啦')
              theResult = 0;
              if (data.result != 0) {
                alert(data.message);
              }
            },
            error: function () {
              theResult = 0;
              // alert("ajax error!");
            }
          }
        );

        setTimeout(function () {
          if (theResult != 0) {
            alert("需安装客户端视频软件");
          }
        }, 500);
      }
    },
    // watch: {
    //   '$route': 'getParams'
    // },
    created() {
      this.Confid = getLocalStorage('formid')
      http.post('/conference/getDailyConferenceDetail.json', {"id": this.Confid }).then(res => {
        // console.log('会议详情')
        // console.log(res)
        if (res.data.code === _.ERR_OK) {
          this.studyList=res.data.model.studyList
          this.caseList=res.data.model.caseList
          this.attachList=res.data.model.attachList
          // console.log(res.data.model.startDateStr)
          let confType = ''
          if(res.data.model.confType == 1) {
            confType = '晨读会'
          } else if(res.data.model.confType == 2) {
            confType = '业务学习'
          }
          this.events.title = res.data.model.startDateStr.slice(0,res.data.model.startDateStr.indexOf(' '))+' '+res.data.model.confName
          this.events.confType = confType
          this.events.startTime = res.data.model.startDateStr.slice(res.data.model.startDateStr.indexOf(' ')+1,res.data.model.startDateStr.length)
          this.events.endTime = res.data.model.endDateStr.slice(res.data.model.endDateStr.indexOf(' ')+1,res.data.model.endDateStr.length)
          this.Confstatus = res.data.model.status
          this.thirdConfId = res.data.model.confId //第三方会议id
          //新增人员
          this.NewConfmenber()
          //查询业务关联的影像列表
          let studyListparam = {
            refId: this.Confid,
            businessType: 'conference'
          }
          http.post('/system/getRelateStudyList.json', studyListparam).then(res => {
            // console.log('关联的影像列表')
            // console.log(res)
            this.data1 = []
            if (res.data.code === _.ERR_OK) {
              for(let item of res.data.model) {
                let ageVal = ''
                if(item.patientSex == 'F') {
                  ageVal = '女'
                } else {
                  ageVal = '男'
                }
                let caseAge = ''

                if(item.patientAge == undefined) {
                  caseAge = ""
                } else if(item.patientAge.indexOf('岁')>0) {
                  caseAge = item.patientAge
                }else{
                  item.patientAge + changeAge(item.ageUnit)
                }
                this.data1.push({
                  mediId: item.mediId,
                  patientAge: caseAge,
                  patientSex: ageVal,
                  examTypeName: item.examTypeName,
                  examBodyName: item.examBodyName,
                  hospitalId: item.hospitalId,
                  studyPk: item.studyPk,
                  studyUid: item.studyUid,
                  reportState: item.reportState
                })
              }
            }
          }).catch(() => {

          })
          //查询业务关联的病例列表
          let caseListparams = {
            refId: this.Confid,
            businessType: 'conference'
          }
          http.post('/system/getRelateCaseList.json', caseListparams).then(res => {
            // console.log('关联的病例列表')
            // console.log(res)
            this.data3 = []
            if (res.data.code === _.ERR_OK) {
              for(let item of res.data.model) {
                let SexVal = ''
                if(item.caseSex == '0') {
                  SexVal = '女'
                } else {
                  SexVal = '男'
                }
                let privateTypeVal = ''
                if(item.privateType == '0') {
                  privateTypeVal = '公共'
                } else if(item.privateType == '1') {
                  privateTypeVal = '个人'
                } else if(item.privateType == '2') {
                  privateTypeVal = '部门公开'
                } else {
                  privateTypeVal = '医院公开'
                }
                let caseAge = ''
                if(item.caseAge !== undefined) {
                  caseAge = item.caseAge + changeAge(item.ageUnit)
                } else {
                  caseAge = ''
                }
                this.data3.push({
                  caseName: item.caseName,
                  caseSex: SexVal,
                  caseAge: caseAge,
                  privateType: privateTypeVal,
                  id: item.id
                })
              }
            }
          }).catch(() => {

          })
          //查询业务关联的附件列表
          let attachListparams = {
            refId: this.Confid,
            businessType: 'conference'
          }
          http.post('/system/getRelateAttachList.json', attachListparams).then(res => {
            // console.log('关联的附件列表')
            // console.log(res)
            this.fileannex = []
            this.picannex = []
            if (res.data.code === _.ERR_OK) {
              // console.log(res.data.model)
              for(let item of res.data.model) {
                if(item.attach_type == 'image') {
                  this.picannex.push({
                    refId: item.fileid,
                    label: item.attach_name,
                    filePathUrl: item.fileurl,
                    attach_type: item.attach_type
                  })
                } else {
                  this.fileannex.push({
                    refId: item.fileid,
                    label: item.attach_name,
                    filePathUrl: item.fileurl,
                    attach_type: item.attach_type
                  })
                }
              }
            }
          }).catch(() => {

          })
        }
      }).catch(() => {

      })

      http.post('/getUserInfo.json').then(res => {
        // console.log('登录用户信息')
        // console.log(res)
        if (res.data.code === _.ERR_OK) {
          this.userName = res.data.model.userName
        }
      }).catch(() => {

      })
      this._getTreeData()
      this._getTreeData(1)
      this.getTableList()
    },

     updated(){
 /*      http.post('/conference/getDailyConferenceDetail.json', {"id": this.Confid }).then(res => {
        if (res.data.code === _.ERR_OK) {
          this.studyList=res.data.model.studyList
          this.caseList=res.data.model.caseList
          this.attachList=res.data.model.attachList
          }
       }) */
     }
   }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'

  .w98
    width: 98%
    height auto
    margin: 0 auto
  .layout-left
    float: left
    height: calc(100vh  - 180px)
    margin-top: 20px;
    background: #fff
    width: 300px
  .layout-right
    float: right
    margin-top: 18.5px;
    background: #fff
    height: calc(100vh - 180px)
    width: calc(99% - 300px)
    min-height: 470px
    overflow: auto
  .tiny-page
    float right
    margin-top 8px
    min-width 70px
    max-width 220px

  //图片上传显示
  .img_area
    display: flex
    align-items: center
    justify-content: center
    max-width: 100%
  //标题栏
   .daily-title
      width: 100%
      height: 50px
      background: #fff
      line-height: 50px
      .el-tag
        float:left
        margin-left: 30px;
        margin-top: 15px;
        color:#fff
      .bigtit
        font-size:24px
        float:left
        color #000
        font-weight bold
        text-indent: 10px;
      span
        float:left
        font-size: 13px;
        margin-left: 30px;
        color:$color-green
    .members
      margin-right: 20px;
      .el-badge
        padding: 0 10px;
    .open-vedio
      float:  right
      margin-top 10px
      margin-right 10px
      background: $color-green
      color:#fff

  .check
    background : #e2e8f6;

  .img-table
    max-height 100%
    overflow hidden
  .result-con
    background #fff
    border-top:1px solid #dbdbdb
    .Image,.Result
      color #000
      min-height calc((100vh - 180px)*0.4*0.5 - 25px)
      margin-top: 10px
      span
        display block
        font-weight bold
        padding-left: 10px
        width: 80px
        line-height: 26px
      .content
        line-height: 26px
        text-indent 2em
    .Image
      margin-top: 30px;

  //影像左侧列表
  .currentList
    height calc((100vh - 180px)*0.6 - 90px)
    table
      font-size 12px
  .historyList
    font-size 12px
    height calc((100vh - 180px)*0.4)
    border-top:1px solid #dbdbdb
    table
      font-size 12px
    h2
      @extends .result-con .Result span
      color #000
      font-size 14px
      height 35px
      line-height 35px
  //影像右侧报告
  .reportContent
    height 100%
    h2
      text-align center
      position relative
      color #000
      font-size 16px
      font-weight bold
      line-height 40px
  .cur-report
    height 60%
    overflow-y auto
    position relative
    .report
      height calc(100% - 40px)
      // border-bottom 1px solid #e8e9eb

  .checkDetails
    background #fff
    position relative
    height 40%
  .patient-report
    background: $color-background-d
    border-bottom 1px solid  #E8E9EB
    .report-head
      width: 98%
      margin: 0 auto
      padding: 1%
      overflow: hidden
      border-bottom: 1px solid #E8E9EB
      .report-info
        line-height: 28px
        float: left
        margin-right: 20px
        span
          color: $color-text-mid-grey
  .report-btn
    position: absolute
    right: 12px
    top: 0
    a
      display: inline-block
      font-size $font-size-medium
      height: 28px
      width: 78px
      line-height: 28px
      background: $color-background-hover
      color: $color-background-d
      text-align: center
      margin-left: 10px
      border-radius: 3px
  &.t10
      top 10px

  // 病例库
  .medical-content
    height calc(100vh - 180px)
    .el-tabs__nav
      margin-left 30px
  .medicalList
    height calc(100vh - 180px - 90px)


  //病例库弹窗
    .rightCont .searchbar
      float right
      width 50%
      padding-top: 5px
      .radius_input_content
        width 100%
    .right-tab
      height calc(100vh- 180px)
      .blk
        height calc(100vh- 180px -55px)

  .files
    margin-top: 1em
    background: $color-maingrey
    color #fff
    height calc(100vh - 180px - 90px)
    label
      margin-left 10px
    .file-list
      overflow auto
      height calc((100vh - 334px)/2)
      p
        line-height 30px
        display block
        width 100%
        text-overflow ellipsis
        text-indent 1em
        white-space: nowrap
        text-overflow: ellipsis
        overflow: hidden
        &:checked
          background: $color-background
        &:hover
          background: $color-background
    .add-btn
      display: inline-block
      padding: 4px 10px
      margin-left 5px
      height: 20px
      line-height: 20px
      border-radius: 3px
      color: $color-green
      border-color:$color-green
      background: #fff
      position: relative
      input[type=file]
        position: absolute
        top: 0
        left: 0
        opacity: 0
        display: block
        width: 106px
        height: 28px

  .filelist
    float: left
    width: 100%
    // display flex
    // justify-content center
  .piclist
    float: left
    width: 100%
    li
      float: left
      width: 102px
      min-height: 160px
      position: relative
      margin: 0 15px
      i
        position: absolute
        width: 14px
        height: 14px
        border-radius:7px
        background: #fff
        right: -5px
        top: -5px
      b
        text-align: center
        padding: 4px 0
        line-height: 24px
        width: 100px
        display: block
        word-wrap: break-word
        word-break: normal
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
      a
        border: 1px solid #dbdbdb
        display: flex
        align-items:center
        width: 100px
        height: 100px
        img
          max-width: 90px
          max-height: 90px
          margin: 10px auto

  .report-content
    table
      tr
        td
          p
            max-width: calc(100vw - 500px - 104px)

  .hui
    background:#c9cbd1 !important
    color:#fff !important


  .file_area
    display:flex ;
    align-items :center;
    justify-content :center;
    width :100%;
    height : 100%;

  .file_show a
    display:block
    width: 80px
    height: 27px
    line-height:27px
    cursor: pointer
    background: #01abac
    color: #fff
    border-radius: 3px
    text-align: center
    margin:10px auto 0

  .tip
    text-align:center
    font-size:100%


</style>



// WEBPACK FOOTER //
// dailyDetail.vue?866b05ca